import { DEFAULT_CHUNK_VARIANT } from '../media/constants';
import { PLAYBACK_FRAMES_PER_SECOND } from '../../constants';

// Axios retry count for chunk fetch
export const CHUNK_FETCH_RETRY_COUNT = 1;
// Number retries for chunk fetching (given some interval between calls), incase chunk doesnt exist yet
export const LOAD_CHUNK_RETRY_COUNT = 10;

export const CHUNK_INDEX_TOKEN = '((chunkIndex))';
export const CHUNK_STATUS = {
  UNLOADED: 'UNLOADED',
  LOADING: 'LOADING',
  LOADED: 'LOADED',
  FAILED: 'FAILED',
};

export const FRAME_STATUS = {
  REQUESTED: 'REQUESTED',
  LOADING: 'LOADING',
  LOADED: 'LOADED',
};

export const BROADWAY_WORKER_POOL_SIZE = 1;

// Qualitatively this feels like the right amount of buffering.
// TODO: Quantitative analysis to figure out what the best value here might be.
const MINIMUM_NEXT_TIME_IN_SECONDS = 2;
export const MINIMUM_BUFFERED_FRAMES =
  PLAYBACK_FRAMES_PER_SECOND * MINIMUM_NEXT_TIME_IN_SECONDS;
export const NUM_NEXT_CHUNKS_IN_CACHE = 4;
export const NUM_PREV_CHUNKS_IN_CACHE = 2;
export const NUM_CHUNKS_IN_CACHE =
  NUM_PREV_CHUNKS_IN_CACHE + NUM_NEXT_CHUNKS_IN_CACHE + 1; // +1 for the current chunk
export const NUM_FRAMES_TO_BUFFER =
  DEFAULT_CHUNK_VARIANT.chunkSize * NUM_NEXT_CHUNKS_IN_CACHE;

// Don't change the casing of these values, they are used to execute named function calls
export const FRAME_PROCESSOR_WORKER_MESSAGE = {
  CANCEL_FRAMES: 'cancelFrames',
  CHUNK_LOADED: 'chunkLoaded',
  FRAME_READY: 'frameReady',
  INIT_FRAME_WORKER: 'initFrameWorker',
  LOG: 'log',
  PRIORITIZE_FRAME_INDEX: 'prioritizeFrameIndex',
  REQUEST_FRAMES: 'requestFrames',
  UNLOAD_CHUNK: 'unloadChunk',
};

export const LOW_RESOLUTION_HEIGHT = 480;

export const FRAME_EXTRACTION_DEBOUNCE_MS = 500;
